import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <section id="testimonials" className="bg-mist py-24 sm:py-32" aria-labelledby="testimonials-heading" data-id="element-324" data-mp="3mfr6zudrw6oh">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-325" data-mp="3r8amiww0tbvx">
        <Reveal data-id="element-326" data-mp="1hkxrxbfaqv">
          <div className="mx-auto max-w-[720px] text-center" data-id="element-327" data-mp="1ze2fool8uk">
            <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-328" data-mp="3k7g1z9elqu">
              {t.testimonials.eyebrow}
            </p>
            <h2 id="testimonials-heading" className="headline mt-5 text-[32px] font-bold text-ink sm:text-[46px]" data-id="element-329" data-mp="92xkf4mldsgb">
              {t.testimonials.heading}
            </h2>
          </div>
        </Reveal>

        <ul className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-330" data-mp="2auanrp8wvsa9">
          {t.testimonials.items.map((item, i) => <Reveal as="li" key={item.name} delay={i * 0.06} data-id="element-331" data-mp="2fsvpjt3tak0t" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-4xl border border-ink/[0.07] bg-white p-8 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:border-ink/15 hover:shadow-lift" data-id="element-332" data-mp="1sl2nlxb0rw13">
                <div className="flex items-center gap-0.5" aria-label={t.testimonials.ratingLabel} data-id="element-333" data-mp="1ity8mxlcgb69">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-brand text-brand" aria-hidden="true" data-id="element-334" data-mp="2bjeu1bajqrsz" data-mpi={s} />)}
                </div>
                <blockquote className="mt-6 flex-1 text-[19px] font-medium leading-snug tracking-tight text-ink" data-id="element-335" data-mp="26jsgf0qt39jn">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-3 border-t border-ink/[0.07] pt-6" data-id="element-336" data-mp="1xjm8rvhsh3se">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-ink text-[13px] font-semibold text-white" data-id="element-337" data-mp="r3a7vmnl17t4">
                    {item.name.split(' ').map(n => n[0]).join('')}
                  </span>
                  <span className="flex flex-col" data-id="element-338" data-mp="nmnum6is5g72">
                    <span className="text-[14px] font-semibold text-ink" data-id="element-339" data-mp="njtakg3ohxe6">{item.name}</span>
                    <span className="text-[13px] text-ink/55" data-id="element-340" data-mp="simna6b55kda">
                      {item.role} · {item.location}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}